import {all} from 'redux-saga/effects';
import UserAuthSaga from './saga.userAuth';
import ModuleSaga from './saga.module';
import UserSaga from './saga.user';
import SurveySaga from './saga.survey';
import CommonSaga from './saga.common';
import UserDashboardSaga from './saga.userDashboard';
import ReportSaga from './saga.report';

export default function* rootSaga() {
    yield all(
        [
            CommonSaga(),
            UserAuthSaga(),
            ModuleSaga(),
            UserSaga(),
            SurveySaga(),
            UserDashboardSaga(),
            ReportSaga()
        ]
    )
}




// WEBPACK FOOTER //
// ./src/saga/sagas.tsx